import _ from "lodash";
import React from "react";
import classes from "./CheckListView.scss";
import { connect } from "react-redux";
import I18nHOC from "UIComponents/I18nHOC";
import { compose } from "lib/apolloClient";

import {
  createChecklistItem,
  createChecklistOptionItem,
  deleteChecklistOption,
  deleteChecklistItem,
  writeChecklistElementLocal,
} from "Checklist/modules/ChecklistModule";

import { updateField } from "modules/FieldUpdateThunks";
import CheckListViewRow from "./CheckListViewRow";
import AIJustification from "UIComponents/AIJustification";
import { getGroupedJustifications } from "ClassRoom/modules/utils";

const MIN_OPTION_COUNT = 2;

const CheckListComp = ({
  checklistItems,
  checklistOptionItems,
  toolEvaluationResponses,
  updateEvaluationCell,
  isEvaluation,
  showInsight,
  isEvaluatedByStudent,
  insights,
  insightColor,
  t,
  toolStyles,
  showHeader,
  evaluationCellRefs,
  showRevampedEvaluationUI,
  isSharedWithStudent,
  showOnlyDefaultCursor,
  isAiEvaluationEnabled,
  onAcceptAIEvaluation,
  isGeneratingAIResponse,
}) => {
  const { checkListContainerStyle = {} } = toolStyles || {};

  return (
    <div className={classes.checkListContainer} style={checkListContainerStyle}>
      {showHeader ? (
        <CheckListViewRow
          toolEvaluationResponses={toolEvaluationResponses}
          key={"temp"}
          header={true}
          label={t("assessmentEvaluation:indicator")}
          showInsight={showInsight}
          options={checklistOptionItems}
          index={0}
          minOptionCount={MIN_OPTION_COUNT}
          id={"temp"}
          isEvaluatedByStudent={isEvaluatedByStudent}
          toolStyles={toolStyles}
          showRevampedEvaluationUI={showRevampedEvaluationUI}
          showOnlyDefaultCursor={showOnlyDefaultCursor}
          isGeneratingAIResponse={isGeneratingAIResponse}
        />
      ) : null}
      {_.map(checklistItems, (item, index) => {
        const isLastRow = index === _.size(checklistItems) - 1;

        return (
          <CheckListViewRow
            updateEvaluationCell={updateEvaluationCell}
            toolEvaluationResponses={toolEvaluationResponses}
            key={item.id}
            label={item.label}
            insights={insights}
            showInsight={showInsight}
            insightColor={insightColor}
            rowId={item.id}
            options={checklistOptionItems}
            index={index}
            minOptionCount={MIN_OPTION_COUNT}
            id={item.id}
            isEvaluation={isEvaluation}
            isEvaluatedByStudent={isEvaluatedByStudent}
            toolStyles={toolStyles}
            evaluationCellRefs={evaluationCellRefs}
            isLastRow={isLastRow}
            showRevampedEvaluationUI={showRevampedEvaluationUI}
            isSharedWithStudent={isSharedWithStudent}
            onAcceptAIEvaluation={onAcceptAIEvaluation}
            isAiEvaluationEnabled={isAiEvaluationEnabled}
            showOnlyDefaultCursor={showOnlyDefaultCursor}
            isGeneratingAIResponse={isGeneratingAIResponse}
          />
        );
      })}
    </div>
  );
};
class CheckListView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { showToolList: false };
    this.evaluationCellRefs = {};
  }

  render() {
    const {
      showInsight,
      checklist,
      toolEvaluationResponses,
      updateEvaluationCell,
      isEvaluation,
      isEvaluatedByStudent,
      insights,
      insightColor,
      containerStyle,
      t,
      toolStyles,
      showHeader = true,
      showRevampedEvaluationUI = false,
      isSharedWithStudent,
      showOnlyDefaultCursor = false,
      isAiEvaluationEnabled,
      onAcceptAIEvaluation,
      isGeneratingAIResponse,
      userType,
    } = this.props;

    const isStaff = userType === "staff";

    if (!checklist) {
      return (
        <div className={classes.emptyText}>
          {t("assessmentEvaluation:no_checklist_defined")}
        </div>
      );
    }

    const { checklistItems, checklistOptionItems } = checklist;

    const evaluationJustification = getGroupedJustifications({
      indicators: checklistItems,
      criterias: checklistOptionItems,
      toolEvaluationResponses,
    });

    return (
      <div className={classes.container} style={containerStyle}>
        <CheckListComp
          t={t}
          showInsight={showInsight}
          updateEvaluationCell={updateEvaluationCell}
          insights={insights}
          insightColor={insightColor}
          isEvaluation={isEvaluation}
          checklistItems={checklistItems}
          toolEvaluationResponses={toolEvaluationResponses}
          checklistOptionItems={checklistOptionItems}
          isEvaluatedByStudent={isEvaluatedByStudent}
          toolStyles={toolStyles}
          showHeader={showHeader}
          evaluationCellRefs={this.evaluationCellRefs}
          showRevampedEvaluationUI={showRevampedEvaluationUI}
          isSharedWithStudent={isSharedWithStudent}
          onAcceptAIEvaluation={onAcceptAIEvaluation}
          isAiEvaluationEnabled={isAiEvaluationEnabled}
          showOnlyDefaultCursor={showOnlyDefaultCursor}
          isGeneratingAIResponse={isGeneratingAIResponse}
        />

        {isStaff &&
        isAiEvaluationEnabled &&
        !_.isEmpty(evaluationJustification) ? (
          <AIJustification
            justifications={evaluationJustification}
            isAIGeneratingResponse={isGeneratingAIResponse}
          />
        ) : null}
      </div>
    );
  }
}

const mapActionCreators = {
  createChecklistItem,
  createChecklistOptionItem,
  deleteChecklistOption,
  deleteChecklistItem,
  writeChecklistElementLocal,
  updateField,
};

const mapStateToProps = state => {
  return {
    userType: _.get(state, "login.userInfo.user_type", ""),
  };
};

export default compose(
  I18nHOC({ resource: "assessmentEvaluation" }),
  connect(mapStateToProps, mapActionCreators)
)(CheckListView);
